import React, { useRef, useState } from 'react';
import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
import { cloneDeep } from 'lodash';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import * as action from '../../Store/Pom.action';
import { usePOMGroupState } from './PomGroupContext';
import { toasterMsg } from '../../../../../Components/Toaster/Toaster';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';

const AsyncTypeahead = asyncContainer(Typeahead);

function PomLibraryTable() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const typeaheadConfig = useRef(null);

  const { pomGroupState, setPomGroupState, loggedInUserId } = usePOMGroupState();
  const [suggestionLoader, setsuggestionLoader] = useState(false);

  const handleBomView = () => {
    setPomGroupState((prev) => ({
      ...prev,
      tableView: !prev.tableView,
    }));
  };

  const handleMultiDelete = () => {
    const pomData = cloneDeep(pomGroupState?.pomTableData);
    const updatedItems = pomData?.filter((item) => !pomGroupState?.selectedPOM?.includes(item._id));
    setPomGroupState((prev) => ({
      ...prev,
      pomTableData: updatedItems,
      selectedPOM: [],
    }));
  };

  const filterByLibrary = (option, props) => {
    const referenceCode = option?.code ? option?.code?.toLowerCase() : '';
    const bomDescription = option?.description ? option?.description?.toLowerCase() : '';
    const search = props.text.trim().toLowerCase();
    return referenceCode.includes(search) || bomDescription.includes(search);
  };

  const promiseSearch = async (inputValue) => {
    setsuggestionLoader((prev) => !prev);
    const params = {
      searchText: inputValue,
      loggedInUserId,
    };

    await dispatch(action.getAllPom(params, t));
    setsuggestionLoader((prev) => !prev);
  };

  const onAutoSuggestion = async (selected) => {
    const typeaheadConfigRef = typeaheadConfig.current;
    const pomData = cloneDeep(pomGroupState?.pomTableData);

    const isAlreadyInArray = pomData?.filter((item) => item?._id === selected[0]?._id);
    if (isAlreadyInArray?.length) {
      toasterMsg(t('POM_GROUP.POM_EXIST'), 'danger');
    } else {
      const data = selected[0];

      pomData.push(data);
      setPomGroupState((prev) => ({
        ...prev,
        pomTableData: pomData,
      }));
    }
    if (typeaheadConfigRef) typeaheadConfigRef.clear();
  };

  return (
    <Container className="mt-24 product-care-list" fluid>
      <div className="d-flex pt-list">
        <div className="filter-container">
          <form className="w-342px">
            <div className="library-input xs-w-other">
              <AsyncTypeahead
                ref={typeaheadConfig}
                promptText={t('POM_GROUP.NO_PRODUCT_FOUND')}
                placeholder={t('POM_GROUP.SEARCH_POM_LIBRARY')}
                isLoading={suggestionLoader}
                labelKey="code"
                filterBy={filterByLibrary}
                onSearch={(query) => promiseSearch(query)}
                useCache={false}
                options={pomGroupState?.libraryList}
                minLength={1}
                onChange={(selected) => onAutoSuggestion(selected)}
                id="typeheadWithLibrary"
                renderMenuItemChildren={(options) => (
                  <div className="d-flex" key={options.code}>
                    <div className="list-text">
                      {options?.code}-{options?.description}
                    </div>
                  </div>
                )}
                autoFocus
              />
            </div>
          </form>
        </div>
        <CustomTooltip tooltipText={t('COMMON_LABEL.DELETE')}>
          <button
            type="button"
            className="btn common-btn btn-outline"
            onClick={() => {
              handleMultiDelete();
            }}
            disabled={!pomGroupState?.selectedPOM.length}
            aria-label={t('POM_GROUP.DELETE_SELECTED')}
          >
            <i className="icon-Delete f-24" />
          </button>
        </CustomTooltip>
        <CustomTooltip tooltipText={pomGroupState?.tableView ? 'Card view' : 'Table View'}>
          <button
            className="btn common-btn btn-outline"
            onClick={handleBomView}
            type="button"
            aria-label={pomGroupState?.tableView ? 'Card view' : 'Table View'}
          >
            <i className={pomGroupState?.tableView ? 'icon-grid_view_new f-24' : 'icon-CO-TableView f-24'} />
          </button>
        </CustomTooltip>
      </div>
    </Container>
  );
}

export default PomLibraryTable;
